export default "/static/assets/6cbd75b5471dc662.png"